export default __webpack_public_path__ + "static/media/olc.e842e00d.jpg";